import { Component } from '@angular/core';
import { TimelineModule } from 'primeng/timeline';


interface GridElement {
  title: string;
  description: string;
  icon: string;
  color: string
}

@Component({
  selector: 'app-home-stepper',
  standalone: true,
  imports: [TimelineModule],
  templateUrl: './home-stepper.component.html',
  styleUrl: './home-stepper.component.scss'
})
export class HomeStepperComponent {
  gridElements: GridElement[] = [

    {
      title: 'Buildings',
      description: 'Add depth and detail to structures with versatile editing tools.',
      icon: 'city',
      color: "var(--primary-color)"
    },
    {
      title: 'Roads',
      description: 'Design intricate paths and highways with precision tools.',
      icon: 'road',
      color: "var(--primary-color)"
    },
    {
      title: 'POI Glow',
      description: 'Make points of interest pop with vibrant, adjustable glows.',
      icon: 'lightbulb-on',
      color: "var(--primary-color)"
    },
    {
      title: 'Water',
      description: 'Customize water color and style to match any environment.',
      icon: 'raindrops',
      color: "var(--primary-color)"
    },
    {
      title: 'Material Shaders',
      description: 'Fine-tune terrain or material textures and styles for unique surface finishes.',
      icon: 'leaf',
      color: "var(--primary-color)"
    },
    {
      title: 'Texturize',
      description: 'Apply patterns and details to any element seamlessly.',
      icon: 'floor',
      color: "var(--primary-color)"
    },
  ]
}
